import React from 'react';
import Select from 'react-select';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useDispatch} from 'react-redux';
// import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {
    messageError,
    messageToast,
    objectRoles,
    typeError,
    styleSelectError,
    styleSelectDefault
} from '../../utils/define';
import {addAccountAction} from '../../store/reducers/account';
import { ROLE_API, POSITION_API, ACCOUNT_POSITION_API, ACCOUNT_EMAIL_API } from '@app/utils/apiUrl';
import {Get, Post} from '../../utils/httpProvider';
import {useQuery} from 'react-query';
import {AsyncPaginate} from 'react-select-async-paginate';

const schema = yup.object().shape({
    username: yup.string().required(messageError.emptyMessage),
    firstName: yup.string().required(messageError.emptyMessage),
    lastName: yup.string().required(messageError.emptyMessage),
    email: yup
        .string()
        .email(messageError.emailMessage)
        .required(messageError.emptyMessage),
    password: yup
        .string()
        .min(6, messageError.minLength6Message)
        .max(30, messageError.maxLength30Message)
        .required(messageError.emptyMessage),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('password'), null], messageError.likePassword)
        .required(messageError.emptyMessage),
    roles: yup.array().min(1, messageError.emptyMessage)
});

const AccountAdd = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const handleCreate = async (values, actions) => {
        const model = {...values};
        const selectedPositionId = model.positionId || null;
        delete model.positionId;
        // const roleAccount =
        //     model.roles.length > 0 ? model.roles.map((x) => x.value) : [];
        // model.roles = roleAccount;
        try {
            const result = await dispatch(addAccountAction(model));
            if (result.meta.requestStatus === 'rejected') {
                const payload = result.payload;
                if (payload && payload.errors) {
                    if (payload.type === typeError.UserName) {
                        actions.setErrors({
                            username: payload.errors.content[0]
                        });
                    }
                    if (payload.type === typeError.Email) {
                        actions.setErrors({
                            email: payload.errors.content[0]
                        });
                    }
                } else {
                    toast.error(payload?.message || payload?.Errors?.content?.[0] || 'Tạo tài khoản không thành công');
                }
            } else {
                const accountId = result.payload;
                // Dual write Email to WebApi
                if (accountId && values.email) {
                    try {
                        const fullName = `${values.lastName} ${values.middleName || ''} ${values.firstName}`.replace(/\s+/g, ' ').trim();
                        const resEmail = await Post(ACCOUNT_EMAIL_API.UPSERT, null, {
                            accountId: accountId,
                            email: values.email?.trim(),
                            fullName
                        });
                        const dataEmail = await resEmail.json();
                        if (dataEmail?.isDuplicate && dataEmail?.warning) {
                            toast.warn(dataEmail.warning);
                        }
                    } catch (emailErr) {
                        console.error('Error dual-writing email', emailErr);
                    }
                }

                // Dual write Position to WebApi
                if (selectedPositionId) {
                    try {
                        const positionResponse = await Post(ACCOUNT_POSITION_API.UPSERT, null, {
                            accountId: accountId,
                            positionId: selectedPositionId
                        });
                        if (!positionResponse?.ok) {
                            throw new Error('Đồng bộ vị trí sang WebApi thất bại');
                        }
                    } catch (posError) {
                        console.error('Error dual-writing position', posError);
                        toast.warn('Tạo tài khoản thành công nhưng chưa đồng bộ được vị trí sang WebApi.');
                    }
                }

                toast.success(messageToast.messageToastCreateSuccess);
                history.goBack();
            }
        } catch (error) {
            toast.error(messageToast.messageToastTryCatch);
        }
    };

    const listRole = useQuery(['getAllRolesFromAuthServer'], () =>
            Get(ROLE_API.GET_PAGING, null, {
                PageIndex: 1,
                PageSize: 10000
            })
        );
    
        const lstRole =
            listRole &&
            listRole.data &&
            listRole.data.data &&
            listRole.data.data.length > 0
                ? listRole.data.data.map((x) => ({
                      name: x.name,
                      id: x.id
                  }))
                : [];
    
        const loadOptions = async (inputValue, loadedOptions, {page}) => {
            const filtered = lstRole
                .filter((o) =>
                    o.name.toLowerCase().includes(inputValue.toLowerCase())
                )
                .slice(0, 6);
            return {
                options: filtered,
                hasMore: false,
                additional: {page: page + 1}
            };
        };

    const { data: positionsData } = useQuery(['getAllActivePositions'], async () => {
        const res = await Get(POSITION_API.GET_ALL_ACTIVE, null, null);
        return Array.isArray(res) ? res : (res?.data || []);
    });
    const positionOptions = (positionsData || []).map((pos) => ({
        value: pos.id,
        label: pos.name
    }));

    return (
        <Card>
            <Card.Header as="h5">Thêm tài khoản</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values, actions) =>
                        handleCreate(values, actions)
                    }
                    initialValues={{
                        username: '',
                        // fullname: '',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        email: '',
                        // password: '',
                        // confirmPassword: '',
                        phoneNumber: '',
                        // pseudonym: '',
                        isActive: false,
                        lstAllowedRoles: [],
                        positionId: ''
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tài khoản *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Tài khoản"
                                        type="text"
                                        name="username"
                                        value={values.username}
                                        onChange={handleChange}
                                        isInvalid={!!errors.username}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.username}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Họ *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Họ"
                                        name="lastName"
                                        value={values.lastName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.lastName}
                                    />

                                    <Form.Control.Feedback type="invalid">
                                        {errors.lastName}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên đệm
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Tên đệm"
                                        name="middleName"
                                        value={values.middleName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.middleName}
                                    />

                                    <Form.Control.Feedback type="invalid">
                                        {errors.middleName}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Tên"
                                        name="firstName"
                                        value={values.firstName}
                                        onChange={handleChange}
                                        isInvalid={!!errors.firstName}
                                    />

                                    <Form.Control.Feedback type="invalid">
                                        {errors.firstName}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Email *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Email"
                                        name="email"
                                        value={values.email}
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.email}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Số điện thoại
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Số điện thoại"
                                        name="phoneNumber"
                                        value={values.phoneNumber}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Form.Group>
                            {/* <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Bút danh
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="text"
                                        placeholder="Bút danh"
                                        name="pseudonym"
                                        value={values.pseudonym}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Form.Group> */}
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Quyền được cho phép truy cập
                                </Form.Label>
                                <Col sm="10">
                                    <AsyncPaginate
                                        isMulti
                                        name="roles"
                                        placeholder="Chọn quyền được cho phép truy cập"
                                        value={values.roles}
                                        getOptionLabel={(opt) => opt.name}
                                        getOptionValue={(opt) => opt.id}
                                        loadOptions={loadOptions}
                                        styles={
                                            errors.roles
                                                ? styleSelectError
                                                : styleSelectDefault
                                        }
                                        onChange={(options) => {
                                            setFieldValue(
                                                'roles',
                                                options
                                            );
                                        }}
                                        additional={{
                                            page: 1
                                        }}
                                    />
                                    <div
                                        className="invalid-feedback"
                                        style={{display: 'block'}}
                                    >
                                        {errors.roles}
                                    </div>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Vị trí
                                </Form.Label>
                                <Col sm="10">
                                    <Select
                                        name="positionId"
                                        placeholder="Chọn vị trí"
                                        isClearable
                                        isSearchable
                                        options={positionOptions}
                                        value={positionOptions.find((opt) => String(opt.value) === String(values.positionId)) || null}
                                        onChange={(option) => {
                                            setFieldValue('positionId', option ? option.value : '');
                                        }}
                                        noOptionsMessage={() => 'Không tìm thấy vị trí'}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mật khẩu *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="password"
                                        placeholder="Mật khẩu"
                                        name="password"
                                        value={values.password}
                                        onChange={handleChange}
                                        isInvalid={!!errors.password}
                                    />

                                    <Form.Control.Feedback type="invalid">
                                        {errors.password}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Xác nhận mật khẩu *
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        type="password"
                                        placeholder="Xác nhận mật khẩu"
                                        name="confirmPassword"
                                        value={values.confirmPassword}
                                        onChange={handleChange}
                                        isInvalid={!!errors.confirmPassword}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.confirmPassword}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Trạng thái kích hoạt
                                </Form.Label>
                                <Col sm="10" className="icheck-primary">
                                    <Form.Control
                                        id="checkboxPrimary1"
                                        type="checkbox"
                                        placeholder="Trạng thái"
                                        name="isActive"
                                        checked={values.isActive}
                                        onClick={handleChange}
                                    />
                                    <Form.Label htmlFor="checkboxPrimary1">
                                        {' '}
                                    </Form.Label>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{span: 10, offset: 2}}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary">
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() => history.goBack()}
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default AccountAdd;
